module.exports = __webpack_public_path__ + "img/DSC_1114.aa698d6e.jpg";